{
  "Absent only": "Absents",
  "Accept": "Accepter",
  "Accepted only": "Acceptées",
  "Active only": "Actifs",
  "Add a stream": "Ajouter un stream",
  "Add an email, Enter to confirm": "Ajouter un email, Entrée pour valider",
  "Added by": "Ajouté par",
  "All statuses": "Tous les statuts",
  "Any request status": "Toutes",
  "Any status": "Tous",
  "Assignment stream": "Stream d'affectation",
  "Between 1 and 52 weeks.": "Entre 1 et 52 semaines.",
  "Boond synchronisation time": "Heure de la synchronisation Boond",
  "Cancelled only": "Annulées",
  "Closed only": "Clos",
  "Computing compliance…": "Calcul de la conformité…",
  "Computing the preview": "Calcul de l'aperçu",
  "Computing the preview…": "Calcul de l'aperçu…",
  "Confirm acceptance": "Confirmer l'acceptation",
  "Confirm refusal": "Confirmer le refus",
  "Create the first internal project.": "Créez le premier projet interne.",
  "Create the project": "Créer le projet",
  "DAR list saved": "Liste DAR enregistrée",
  "DAR members": "Membres de la DAR",
  "DAR rights apply from the person's next request. The DAR keeps at least one member.": "Les droits DAR s'appliquent à la prochaine requête de la personne. La DAR garde au moins un membre.",
  "Date": "Date",
  "Deadline day": "Jour d'échéance",
  "Deadline time": "Heure d'échéance",
  "Deadline: {{deadline}}.": "Échéance : {{deadline}}.",
  "Decide": "Décider",
  "Decision": "Décision",
  "Description": "Description",
  "Description (optional)": "Description (facultatif)",
  "Description of stream {{number}}": "Description du stream {{number}}",
  "Drafts only": "Brouillons",
  "Effective date": "Date d'effet",
  "Effects of the decision": "Effets de la décision",
  "Emails copied on notifications": "Emails en copie des notifications",
  "Emails of the DAR members": "Emails des membres de la DAR",
  "Empty: the deadline time ({{time}}).": "Vide : l'heure d'échéance ({{time}}).",
  "Every project, paused and closed ones included. A project's page carries the DAR actions: status, TL/PO, assignments.": "Tous les projets, y compris en pause et clos. La fiche d'un projet porte les actions de la DAR : statut, TL/PO, affectations.",
  "Everything is filed for this filter.": "Tout est rendu pour ce filtre.",
  "Expected": "Attendus",
  "Filed": "Rendus",
  "Filter by status": "Filtrer par statut",
  "First day of the assignment.": "Premier jour de l'affectation.",
  "First report required": "Premier CRA demandé",
  "How many past-due weeks a reminder can list.": "Combien de semaines échues un rappel peut lister.",
  "Included in the email sent to the person, with the TL/PO in copy.": "Repris dans l'email envoyé à la personne, TL/PO en copie.",
  "Initial streams": "Streams initiaux",
  "Invalid addresses: {{addresses}}": "Adresses invalides : {{addresses}}",
  "Last day of the assignment (inclusive).": "Dernier jour de l'affectation (incluse).",
  "Last reminder": "Dernière relance",
  "Loading projects…": "Chargement des projets…",
  "Loading requests…": "Chargement des demandes…",
  "Loading settings…": "Chargement des paramètres…",
  "Maturity (TRL)": "Maturité (TRL)",
  "Member emails": "Emails des membres",
  "Message": "Message",
  "Message from the person": "Message de la personne",
  "Message to the person (optional)": "Message à la personne (facultatif)",
  "Missing only": "Manquants",
  "Missing or draft": "Manquants et brouillons",
  "New project": "Nouveau projet",
  "No pending requests": "Aucune demande en attente",
  "No projects": "Aucun projet",
  "No reminder sent": "Aucune relance envoyée",
  "No report is expected before this week.": "Aucun CRA n'est attendu avant cette semaine.",
  "No reports expected": "Aucun CRA attendu",
  "No requests": "Aucune demande",
  "No start date": "Pas de date de début",
  "No “{{status}}” requests.": "Aucune demande « {{status}} ».",
  "Nobody was assigned that week.": "Personne n'était affecté cette semaine-là.",
  "Pause the daily synchronisation": "Mettre en pause la synchronisation quotidienne",
  "Paused only": "En pause",
  "Pending only": "En attente",
  "Plain text: line breaks are kept.": "Texte simple : les retours à la ligne sont conservés.",
  "Product owners": "Product owners",
  "Project": "Projet",
  "Rate": "Taux",
  "Refuse": "Refuser",
  "Refused only": "Refusées",
  "Remind": "Relancer",
  "Remind the selection": "Relancer la sélection",
  "Remind the selection ({{size}})": "Relancer la sélection ({{size}})",
  "Reminder time": "Heure des relances",
  "Reminder window (weeks)": "Fenêtre de relance (semaines)",
  "Remove stream {{number}}": "Retirer le stream {{number}}",
  "Report": "CRA",
  "Report deadline and reminders, Boond synchronisation, copied recipients and DAR members.": "Échéance et relances des CRA, synchronisation Boond, destinataires en copie et membres de la DAR.",
  "Reports and synchronisation": "Comptes rendus et synchronisation",
  "Request": "Demande",
  "Request accepted": "Demande acceptée",
  "Request refused": "Demande refusée",
  "Request status": "Statut des demandes",
  "Requests to join or leave a project. The decision starts or ends the assignment, and notifies the person and the TL/PO by email.": "Les demandes pour rejoindre ou quitter un projet. La décision affecte ou termine l'affectation, et prévient la personne et les TL/PO par email.",
  "Save the list": "Enregistrer la liste",
  "Save the settings": "Enregistrer les paramètres",
  "Select {{name}} ({{project}})": "Sélectionner {{name}} ({{project}})",
  "Settings saved": "Paramètres enregistrés",
  "Since": "Depuis",
  "Status": "Statut",
  "Stream title": "Titre du stream",
  "Stream {{number}}": "Stream {{number}}",
  "Stream “{{stream}}”": "Stream « {{stream}} »",
  "Tech leads": "Tech leads",
  "The DAR creates the project and appoints its TL/PO; they then edit its content and streams.": "La DAR crée le projet et nomme ses TL/PO ; eux en éditent ensuite le contenu et les streams.",
  "The title is required.": "Le titre est obligatoire.",
  "These people were already reminded today, or have nothing left to file.": "Ces personnes ont déjà été relancées aujourd'hui, ou n'ont plus rien à rendre.",
  "Time expected as HH:MM.": "Heure attendue au format HH:MM.",
  "Time zone: {{timezone}}.": "Fuseau horaire : {{timezone}}.",
  "Title": "Titre",
  "Week": "Semaine",
  "Weeks reminded: {{weeks}}.": "Semaines relancées : {{weeks}}.",
  "Who filed their report, project by project, for a given week. A reminder goes out at most once a day per person, and lists everything they are missing.": "Qui a rendu son compte rendu, projet par projet, pour une semaine donnée. Une relance part au plus une fois par jour et par personne, et liste tous ses manques.",
  "Whole project": "Tout le projet",
  "Without any stream entered, the project starts with a “General” stream.": "Sans stream saisi, le projet démarre avec un stream « Général ».",
  "W{{number}}": "S{{number}}",
  "You are removing yourself from the DAR: you will lose access to the administration.": "Vous vous retirez de la DAR : vous perdrez l'accès à l'administration.",
  "You can assign to a stream other than the one requested.": "Vous pouvez affecter à un autre stream que celui demandé.",
  "address@diametral.com, Enter to add": "adresse@diametral.com, Entrée pour ajouter",
  "effective {{date}}": "effet le {{date}}",
  "not in Boond": "hors Boond",
  "requested on {{date}}": "demande du {{date}}",
  "the request from {{name}}": "la demande de {{name}}",
  "{{count}} reminders sent_one": "{{count}} relance envoyée",
  "{{count}} reminders sent_other": "{{count}} relances envoyées",
  "{{day}} after the week": "{{day}} suivant la semaine",
  "{{name}} is notified by email (effective {{date}}).": "{{name}} est prévenu(e) par email (effet le {{date}}).",
  "{{name}} is notified by email.": "{{name}} est prévenu(e) par email.",
  "{{name}} wants to join {{project}}": "{{name}} souhaite rejoindre {{project}}",
  "{{name}} wants to leave {{project}}": "{{name}} souhaite quitter {{project}}",
  "{{rate}}%": "{{rate}} %",
  "{{title}} (requested)": "{{title}} (demandé)"
}
